import GenericLoader from "@/components/ui/GenericLoader";
import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

// Lazy imports
const Properties = lazy(() => import("@/pages/properties/Properties"));
const PropertyPage = lazy(() => import("@/pages/properties/PropertyPage"));

const messages = [
  "Scouting the neighborhood for you...",
  "Hunting down the best listings...",
  "Retrieving your future views...",
  "Mapping out your options...",
];
export default function PropertyRoutes() {
  return (
    <Suspense
      fallback={
        <GenericLoader
          type={"property"}
          message={messages[Math.floor(Math.random() * messages.length)]}
        />
      }
    >
      <Routes>
        <Route path="/*">
          <Route index element={<Properties />} />
          <Route path=":propertySlug" element={<PropertyPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
